<template>
  <div class="d-inline-block">
    <template v-for="(item, index) in transformedFlow" :key="index">
      <span class="page-title">
        <template v-if="item.link">
          <!-- Use router-link for navigation if history is false -->
          <router-link v-if="!history" :to="item.link">{{ item.text }}</router-link>
          <!-- Use an anchor tag and custom go function if history is true -->
          <a v-else @click="go(index)">{{ item.text }}</a>
        </template>
        <template v-else>
          <!-- Display the text if there is no link -->
          {{ item.text }}
        </template>
      </span>
      <!-- Show the "Next Page" icon if item has a link -->
      <img
        v-if="item.link"
        :key="'img' + index"
        src="../assets/icons/iconNextPage.svg"
        class="mx-1 mt-less-2"
        alt="Next Page Icon"
      />
    </template>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { computed } from 'vue';

export default {
  props: {
    flow: {
      type: Array,
      required: true,
    },
    history: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const router = useRouter();

    // Replace "LMTs" text dynamically with "CAOs"
   const transformedFlow = computed(() =>
  props.flow.map((item) => {
    let newText = item.text;

    const txt = item.text?.toLowerCase().trim();

    if (txt === 'lmts') {
      newText = 'CAOs';
    } else if (txt === 'agent receivable report') {
      newText = 'ATM Locations Receivable Report';
    } else if(txt==='store agents'){
      newText = 'ATM Locations';
    }
    else if(txt==='create agent'){
      newText = 'Create ATM Location';
    }
    else if(txt==='lmt balance'){
      newText = 'CAO Balance';
    }
     else if(txt==='lmt'){
      newText = 'CAO';
    }
    
     

    return {
      ...item,
      text: newText,
    };
  })
);



    const go = (index) => {
      const totalSteps = props.flow.length - index + 1;
      router.go(-totalSteps);
    };

    return {
      go,
      transformedFlow, // ✅ return it so template can use it
    };
  },
};
</script>

<style scoped>
.mx-1 {
  margin: 0 0.25rem;
}
.mt-less-2 {
  margin-top: -2px !important;
}
</style>
